'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _xmpp = require('@xmpp/client/dist/xmpp');
var _constants = require('./constants');
var _plugins = require('./plugins');
var _plugins2 = _interopRequireDefault(_plugins);
var _exceptions = require('./exceptions');
var _xmppHelper = require('./helpers/xmppHelper');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var XMPP = function XMPP(connectionData, _ref) {
  var netInfo = _ref.netInfo,
    shouldAutoLoadRooms = _ref.shouldAutoLoadRooms;
  _classCallCheck(this, XMPP);
  _initialiseProps.call(this);
  this.internetIsConnected = true;
  this.shouldAutoLoadRooms = shouldAutoLoadRooms;
  this.connectionInfo = (0, _xmppHelper._buildConnectionInfo)(connectionData);
  this.cachedUsername = this.connectionInfo.username;
  this.listeners = [];
  this.reconnectListeners = [];
  this._createInternetListeners(netInfo);
  this._createConnection();
  this._initializePlugins();
}

/**
   * External API
   */

/**
   * Internal functions
   */;
var _initialiseProps = function _initialiseProps() {
  var _this = this;
  this.connect = function () {
    if (_this.getConnStatus() === 'disconnect') {
      _this.client.stop();
      _this.client.once('offline', _this._doConnect);
    } else if (_this.getConnStatus() === 'offline') {
      _this._doConnect();
    }
  };
  this.disconnect = function () {
    _this.getPlugin('lastTimestampHandler').clear();
    return _this.client.stop();
  };
  this.disconnectAndConnect = function () {
    _this.disconnect().then(_this.connect);
  };
  this.isConnected = function () {
    return _constants.XMPPOnlineEvents.indexOf(_this.getConnStatus()) !== -1;
  };
  this.send = function (stanza) {
    return _this.client.send(stanza);
  };
  this.getUsername = function () {
    if (!_this.cachedUsername && _this.client.jid) {
      _this.cachedUsername = _this.client.jid.getLocal();
    }
    return _this.cachedUsername;
  };
  this.startReconnection = function () {
    _this.client.reconnect.start();
  };
  this.stopReconnection = function () {
    _this.client.reconnect.stop();
  };
  this.setReconnectionDelay = function (newValue) {
    _this.client.reconnect.delay = newValue;
  };
  this.getReconnectionDelay = function () {
    return _this.client.reconnect.delay;
  };
  this.changeUser = function (username, password) {
    var isUserDifferent = _this.connectionInfo.username !== username || _this.connectionInfo.password !== password;
    _this.connectionInfo = _extends({}, _this.connectionInfo, {
      username: username,
      password: password
    });
    if (!_this.isConnected()) {
      _this._createConnection();
    } else if (isUserDifferent) {
      _this.stopReconnection();
      _this.disconnect().then(_this._createConnection).catch(_this._createConnection);
    }
  };
  this.getConnStatus = function () {
    return _this.client.status || 'disconnect';
  };
  this.getPlugin = function (pluginName) {
    return _this.plugins[pluginName];
  };
  this.on = function (eventName, cb) {
    var wrappedCb = _this._cbWrapper(eventName, cb);
    _this.listeners.push({
      eventName: eventName,
      cb: wrappedCb
    });
    _this.client.on(eventName, wrappedCb);
  };
  this.onError = function (cb) {
    var wrappedCb = _this._cbErrorWrapper(cb);
    _this.listeners.push({
      eventName: _constants.Events.INTERNAL_ERROR,
      cb: wrappedCb
    });
    _this.client.on(_constants.Events.INTERNAL_ERROR, wrappedCb);
  };
  this.onReconnect = function (eventName, cb) {
    var wrappedCb = _this._cbWrapper(eventName, cb);
    _this.reconnectListeners.push({
      eventName: eventName,
      cb: wrappedCb
    });
    _this.client.reconnect.on(eventName, wrappedCb);
  };
  this.emit = function (eventName, value) {
    _this.client.emit(eventName, value);
  };
  this._cbWrapper = function (eventName, cb) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      try {
        cb.apply(undefined, args);
      } catch (ex) {
        _this.emit(_constants.Events.INTERNAL_ERROR, new _exceptions.CallbackException(ex, eventName, args));
      }
    };
  };
  this._cbErrorWrapper = function (cb) {
    return function () {
      try {
        cb.apply(undefined, arguments);
      } catch (ex) {
        console.error('Unexpected error', ex);
      }
    };
  };
  this._doConnect = function () {
    if ((0, _xmppHelper.shouldConnect)(_this.connectionInfo)) {
      _this.client.start().catch(function (error) {
        console.log('CHAT-SDK | connect error', error);
      });
    }
    _this.startReconnection();
  };
  this._createConnection = function () {
    _this.client = (0, _xmpp.client)(_this.connectionInfo);
    _this.client.on('online', _this._cacheUsername);
    _this._reconfigureListeners();
    _this._configureConnectionLog();
    typeof window !== 'undefined' && _this.connect();
  };
  this._cacheUsername = function () {
    if (_this.client.jid) {
      _this.cachedUsername = _this.client.jid.getLocal();
    }
  };
  this._reconfigureListeners = function () {
    _this.listeners.forEach(function (_ref2) {
      var eventName = _ref2.eventName,
        cb = _ref2.cb;
      return _this.client.on(eventName, cb);
    });
    _this.reconnectListeners.forEach(function (_ref3) {
      var eventName = _ref3.eventName,
        cb = _ref3.cb;
      return _this.client.reconnect.on(eventName, cb);
    });
  };
  this._createInternetListeners = function (netInfo) {
    netInfo.isConnected.fetch().then(function (isConnected) {
      _this.internetIsConnected = isConnected;
    });
    netInfo.isConnected.addEventListener('connectionChange', function (isConnected) {
      _this.internetIsConnected = isConnected;
      if (isConnected) {
        _this.startReconnection();
      } else {
        _this.stopReconnection();
      }
    });
  };
  this._initializePlugins = function () {
    _this.plugins = {};
    _plugins2.default.map(function (Plugin) {
      return new Plugin(_this);
    });
  };
  this._configureConnectionLog = function () {
    _constants.XMPPConnectionEvents.forEach(function (event) {
      _this.client.on(event, function () {
        process.env.NODE_ENV === 'development' && console.log('JAIMINHO | EVENT', event);
      });
    });
    _constants.XMPPReconnectionEvents.forEach(function (event) {
      _this.client.reconnect.on(event, function () {
        process.env.NODE_ENV === 'development' && console.log('JAIMINHO | RECONNECT-EVENT', event);
      });
    });
  };
};
exports.default = XMPP;